<template>
  <div class="nav_wrapper" v-resize="onResize" :class="{'active' : systmebarclose}">
    <v-system-bar class="top_fixed_content" :class="{'active' : systmebarclose}">
      <v-layout row class="min_layout">
        <v-flex class="title">
          <v-subheader>{{ $t('common.menu.notice') }}</v-subheader>
        </v-flex>
        <v-flex class="text_content">
          <p v-if="$vuetify.rtl" style="cursor:pointer;" @click="fnGoNoticeView(noticeTop.seq)">{{noticeTop.subject_ar}}</p>
          <p v-if="!$vuetify.rtl" style="cursor:pointer;" @click="fnGoNoticeView(noticeTop.seq)">{{noticeTop.subject_en}}</p>
          <v-btn class="close_btn" @click="systmebarclose = !systmebarclose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-system-bar>
    <v-app-bar
      app
      clipped-left
      color="white"
      class="custom appbar_c"
    >
      <v-toolbar-title class="ml-0 start__logo">
        <div class="top_logo d-flex align-center">
          <div>
            <div @click="fnGoPath('/main')" style="cursor:pointer">
              <v-img style="margin:0 auto;cursor:pointer;" width="122px" src="~@/assets/img/header_logo_sm.png" alt="EGPO Main" title="EGPO Main" />
            </div>
            <div class="logo__btm__title">E-Service</div>
          </div>
          <v-spacer class="hidden_lr10"></v-spacer>

          <div class="logo__text">
            <span>EGPO-SES</span>
            <span><b>S</b>earch and <b>E</b>-service <b>S</b>ystem</span>
          </div>
        </div>
      </v-toolbar-title>

      <v-subheader class="top_fixed_desc">
        <img class="logo__icon" src="~@/assets/img/logo_icon.png" @click="fnGoPath('/main')" style="cursor:pointer;" alt="EGPO Main" title="EGPO Main" />
        <v-spacer class="hidden_lr10"></v-spacer>
        <div class="logo__text">
          <span>EGPO-SES</span>
          <span><b>S</b>earch and <b>E</b>-service <b>S</b>ystem</span>
        </div>
      </v-subheader>

      <v-spacer/>
      <div class="top_fixed_btn_wrapper">
        <span class="ft-size12" style="color:#fff;">{{ appVersion }}</span>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              @click="fnGoCheck2(topMenu.dashboard)"
            ><v-icon color="#a01c2a">mdi-speedometer</v-icon></v-btn>
          </template>
          <span>{{ $t('dashboard.title') }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              @click="fnGoCheck2(topMenu.payment)"
            ><v-icon color="#a01c2a">mdi-credit-card-multiple</v-icon><v-badge :content="topMenu.payment.cnt" :class="{ 'mores' : true}" overlap v-if="topMenu.payment.cnt > 0"></v-badge></v-btn>
          </template>
          <span>{{ $t('payment.title') }}</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              @click="fnGoCheck2(topMenu.duedate)"
            ><v-icon  color="#a01c2a">mdi-calendar-range</v-icon></v-btn>
          </template>
          <span>{{ $t('due_date.title') }}</span>
        </v-tooltip>

        <v-tooltip top v-if="user_group_type_code === '3803' || user_group_type_code === '3804'">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              @click="fnGoCheck2(topMenu.portfolio)"
            ><v-icon color="#a01c2a">mdi-account-box-outline</v-icon></v-btn>
          </template>
          <span>{{ $t('portfolio.title') }}</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              @click="fnGoCheck2(topMenu.notification)"
            ><v-icon color="#a01c2a">mdi-email</v-icon><v-badge :content="topMenu.notification.cnt" :class="{ 'mores' : true}" overlap v-if="topMenu.notification.cnt > 0"></v-badge></v-btn>
          </template>
          <span>{{ $t('notification.title') }}</span>
        </v-tooltip>
        <v-spacer class="hidden_lr20 bar"></v-spacer>

        <div class="lang__selector" tabindex="0">
          <v-switch
            v-model="rtl"
            color="red"
            value="red"
            class=""
            hide-details
            @change="fnSetLocale()"
          ></v-switch>
          <v-spacer class="hidden_lr5"></v-spacer>
          <span v-if="rtl">{{ $t('common.common.arabic') }}</span>
          <span v-else>{{ $t('common.common.english') }}</span>
        </div>
      </div>
      <v-app-bar-nav-icon class="nav_showhide" @click=" slideactive = !slideactive"></v-app-bar-nav-icon>
    </v-app-bar>
    <div class="drawer__wrapper">
      <div class="aside_wrap aside__content__wrapper" :class="{'mobile' : !asidebool, 'slideonoff' : slideactive}">

        <div class="lang__selector ty2 posty">
          <v-switch
            v-model="ex11"
            color="red"
            value="red"
            hide-details
            @change="fnSetLocale()"
          ></v-switch>
          <v-spacer class="hidden_lr5"></v-spacer>
          <span v-if="rtl">{{ $t('common.common.arabic') }}</span>
          <span v-else>{{ $t('common.common.english') }}</span>
        </div>

        <v-btn icon class="close_aside_wrap" @click="slideactive = !slideactive">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-row class="auth_wrap ma-0 mb-14" v-if="auth === true">
          <v-col class="d-flex flex-column">
            <v-btn tabindex="1" class="mb--5" @click="fnGoPath('/signin')"><v-icon class="auth__icon">mdi-lock</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.menu.sign_in') }}</v-btn>
            <v-btn tabindex="2" class="revers" @click="fnGoPath('/signup/usertype')"><v-icon class="auth__icon">mdi-account-circle</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.menu.sign_up') }}</v-btn>
          </v-col>
        </v-row>
        <v-row class="auth_wrap ma-0" v-if="auth === false">
          <v-list-group>
            <template v-slot:activator>
              <v-avatar size="100" class="mb-13 aside__avatar">
                <v-img :src="avatarSrc" alt=""/>
              </v-avatar>
              <h2 class="title mb--5">{{user_name}}</h2>
              <p class="desc">{{company_name}}</p>
            </template>
            <v-list-item>
              <v-row class="normal_user ma-0 mt-20" v-if="user_group_type_code === '3801'">
                <v-col cols="12" class="pa-0">
                  <v-btn class="mb--5" @click="fnGoPath('/user/profile')">{{ $t('common.menu.user_profile') }}</v-btn>
                  <v-btn @click="fnSignOut()">{{ $t('common.menu.sign_out') }}</v-btn>
                </v-col>
              </v-row>

              <v-row class="normal_user ma-0 mt-20" v-if="user_group_type_code === '3802'">
                <v-col cols="12" class="pa-0">
                  <v-btn class="mb--5" @click="fnGoPath('/user/company/profile')">{{ $t('common.menu.user_profile') }}</v-btn>
                  <v-btn @click="fnSignOut()">{{ $t('common.menu.sign_out') }}</v-btn>
                </v-col>
              </v-row>

              <v-row class="normal_user ma-0 mt-20" v-if="user_group_type_code === '3803' || user_group_type_code === '3804'">
                <v-col cols="12" class="pa-0">
                  <v-btn class="mb--5" @click="fnGoPath('/user/agent/profile')">{{ $t('common.menu.user_profile') }}</v-btn>
                  <v-btn class="mb--5" @click="fnGoPath('/user/agent/information')">{{ $t('common.menu.agent_information') }}</v-btn>
                  <v-btn class="mb--5" v-if="ind_representative == 'Y'" @click="fnGoPath('/user/agent/members')">{{ $t('common.menu.agent_members') }}</v-btn>
                  <v-btn @click="fnSignOut()">{{ $t('common.menu.sign_out') }}</v-btn>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list-group>
        </v-row>

        <v-layout class="btn_event_wrap">
          <v-btn icon :style="{'height' : btneventwrapheight + 'px'}" @click="fnGoCheck2(topMenu.dashboard)">
            <v-icon color="#a01c2a">mdi-speedometer</v-icon>
          </v-btn>
          <v-btn icon :style="{'height' : btneventwrapheight + 'px'}" @click="fnGoCheck2(topMenu.payment)">
            <v-icon color="#a01c2a">mdi-credit-card-multiple</v-icon>
          </v-btn>
          <v-btn icon :style="{'height' : btneventwrapheight + 'px'}" @click="fnGoCheck2(topMenu.duedate)">
            <v-icon color="#a01c2a">mdi-calendar-range</v-icon>
          </v-btn>
          <v-btn icon :style="{'height' : btneventwrapheight + 'px'}" @click="fnGoCheck2(topMenu.portfolio)">
            <v-icon color="#a01c2a">mdi-account-box-outline</v-icon>
          </v-btn>
          <v-btn icon :style="{'height' : btneventwrapheight + 'px'}" @click="fnGoCheck2(topMenu.notification)">
            <v-icon color="#a01c2a">mdi-email</v-icon>
            <v-badge :content="topMenu.notification.cnt" :class="{ 'mores' : true}" overlap v-if="topMenu.notification.cnt > 0"></v-badge>
          </v-btn>
        </v-layout>

        <v-list flat light class="side__menu__list__wrap">
          <template v-for="item in items">
            <v-list-group
              :key="item.text"
              v-model="item.model"
              active-class="actv"
              class="menu_items_parent"
              :append-icon="item.children ? (item.model ? item.icon : item['icon-alt']) : ''"
              v-if="(item.login || (!item.login && user_group_type_code)) && item.children"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    <span class="lnb__iconz" :class="item.pricon"></span>
                    <v-spacer class="hidden_lr5 d-inlineb"></v-spacer>
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item-group
                v-model="item.childModel"
                active-class="actv"
              >
                <v-list-item
                  v-for="(child, i) in item.children"
                  :key="i"
                  link
                  active-class="actv"
                  class="menu_items"
                  :id="child.path"
                  @click="fnGoCheck(child)"
                >
                  <v-list-item-content>
                    <v-list-item-title class="d-flex white-space-normal">
                      <v-spacer class="hidden_lr10"></v-spacer>
                      {{ child.text }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list-group>
            <v-list-item v-if="(item.login || (!item.login && user_group_type_code)) && !item.children" :key="item.text" link class="solo"
              @click="fnGoCheck(item)"
            >
              <v-list-item-content>
                <v-list-item-title>
                  <span class="lnb__iconz" :class="item.pricon"></span>
                    <v-spacer class="hidden_lr5 d-inlineb"></v-spacer>
                    {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </div>
    </div>
    <confirm-dialog :id="id" @confirm="fnGoPath2" />
  </div>
</template>

<script>
import requestApi from '@/utils/requestApi'
import eventBus from '@/utils/eventBus'
import store from '@/store'
import ConfirmDialog from '@/components/layout/ConfirmDialog'
import en from 'vee-validate/dist/locale/en'
import ar from 'vee-validate/dist/locale/ar'
import utils from '@/utils/utils'


export default {
  name: 'Appbar',
  components :{
    ConfirmDialog
  },
  data () {
    return {
      id: 'Appbar',
      appVersion: process.env.VUE_APP_VERSION,
      ex11: (store.state.api.language === 'en') ? 'success': 'red',
      rtl: (store.state.api.language === 'en') ? null: 'red',
      systmebarclose : true,
      slideactive : false,
      asidebool : true,
      btneventwrapheight : null,
      auth : false,
      windowSize : '',
      authagent : true,
      authusers : true,
      user_group_type_code: '',
      user_type_code: '',
      ind_representative: '',
      noticeTop : {
        seq: null,
        subject_ar: '',
        subject_en: ''
      },
      badgedata : [
        {
          oom : true,
          data : 0
        }
      ],
      topMenu : {
        portfolio : {
          path: '/portfolio',
          required_login : true,
          return_page_yn : true
        },
        dashboard: {
          path: '/dashboard',
          required_login : true,
          return_page_yn : true
        },
        payment: {
          path: '/payment/list',
          required_login : true,
          return_page_yn : true,
          cnt: 0
        },
        duedate: {
          path: '/duedate',
          required_login : true,
          return_page_yn : true
        },
        notification: {
          path: '/notification',
          required_login : true,
          return_page_yn : true,
          cnt: 0
        }
      },
      items: [],
      downLoadUrl : process.env.VUE_APP_BASE_URL + '/file/download/',
      avatarSrc : ''
    }
  },
  watch:{
    slideactive: function(val) {
      if(val === true){
        document.querySelector('body').style="overflow:hidden"
      }else{
        document.querySelector('body').style="overflow:none"
      }
    },
    //user/profile 페이지 에서 아바타 변경 시 동시 변경 처리
    avatar_file_key() {
      this.fnInit()
    },
    user_name() {
      this.fnInit()
    },
    company_name() {
      this.fnInit()
    }
  },
  mounted () {
    eventBus.$off('NOTIFICATION_RELOAD')
    eventBus.$on('NOTIFICATION_RELOAD', () => {
      this.fnGetNotifiction()
    })

    eventBus.$off('NOTIFICATION_INIT')
    eventBus.$on('NOTIFICATION_INIT', () => {
      this.topMenu.notification.cnt = 0
    })

    eventBus.$off('PAYMENT_RELOAD')
    eventBus.$on('PAYMENT_RELOAD', () => {
      this.fnGetPayment()
    })

    eventBus.$off('PAYMENT_INIT')
    eventBus.$on('PAYMENT_INIT', () => {
      this.topMenu.payment.cnt = 0
    })

    this.fnInit()
    this.onResize()
    this.fnGetNoticeTop()
  },
  computed: {
    //user/profile 페이지 에서 아바타 변경 시 동시 변경 처리
    avatar_file_key: {
      get(){
        return store.state.token.avatar_file_key
      },
      set(){}
    },
    user_name: {
      get() {
        if (store.state.api.language === 'en') {
          return store.state.token.name_en
        } else {
          return store.state.token.name_ar
        }
      },
      set(){}
    },
    company_name: {
      get() {
        if (store.state.api.language === 'en') {
          return store.state.token.company_name_en
        } else {
          return store.state.token.company_name_ar
        }
      },
      set(){}
    }
  },
  methods: {
    fnInit() {
      // store 관련 처리
      this.user_group_type_code = store.state.token.user_group_type_code
      this.user_type_code = store.state.token.user_type_code
      this.ind_representative = store.state.token.ind_representative
      this.avatar_file_key = store.state.token.avatar_file_key

      if (store.state.api.language === 'en') {
        this.$vuetify.rtl = false

        // 아래 부분 추가 - 새로 고침시 i18n 적용되도록
        this.rtl = null
        this.ex11 = 'success'
        this.$i18n.locale = 'en'
        this.$vuetify.lang.current = 'en'
        this.$validator.localize('en', en)
        store.dispatch('SetLanguage', 'en')
      } else if (store.state.api.language === 'ar') {
        this.$vuetify.rtl = true

        // 아래 부분 추가 - 새로 고침시 i18n 적용되도록
        this.rtl = 'red'
        this.ex11 = 'red'
        this.$i18n.locale = 'ar'
        this.$vuetify.lang.current = 'ar'
        this.$validator.localize('ar', ar)
        store.dispatch('SetLanguage', 'ar')
      }

      //아바타 이미지 표시
      if(this.avatar_file_key){
        this.avatarSrc = this.downLoadUrl+this.avatar_file_key
      }else{
        this.avatarSrc = require("@/assets/img/avatar.png")
      }

      //회원 인증 여부
      if(utils.isNull(store.state.token.name_en)){
        this.auth = true
      }else{
        this.auth = false
      }

      this.fnGetMenu()

      // 로그인 했을 경우에만
      if (!this.auth) {
        // 통지서 조회
        this.fnGetNotifiction()
        // unpayment 조회
        this.fnGetPayment()
      }
    },
    fnGetNotifiction() {
      requestApi({
        url: '/users/notification/unread',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.topMenu.notification.cnt = res.data.cnt
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetNotifiction()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetPayment() {
      requestApi({
        url: '/payments/unpay',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.topMenu.payment.cnt = res.data.cnt
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetPayment()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetNoticeTop(){
      requestApi({
        url: '/common/info/notices/top',
        method: 'GET',
        data: '',
        callback: (res) => {
          if (res.res_code === '200') {
            if (res.data) {
              this.systmebarclose = false

              this.noticeTop.seq = res.data.seq
              this.noticeTop.subject_ar = res.data.subject_ar
              this.noticeTop.subject_en = (res.data.subject_en) ? res.data.subject_en : res.data.subject_ar
            }
          } else {
            eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
          }
        }
      })
    },
    fnGoNoticeView(seq){
      this.systmebarclose = true
      let page = {
        name : 'NoticeView',
        params : {
          seq : seq
        }
      }
      this.$router.push(page)
    },
    fnSetLocale () {
      if (this.$vuetify.rtl) {
        this.rtl = null
        this.ex11 = 'success'
        this.$vuetify.rtl = false
        this.$i18n.locale = 'en'
        this.$vuetify.lang.current = 'en'
        this.$validator.localize('en', en)
        this.user_name = store.state.token.name_en
        this.company_name = store.state.token.company_name_en
        store.dispatch('SetLanguage', 'en')
      } else {
        this.rtl = 'red'
        this.ex11 = 'red'
        this.$vuetify.rtl = true
        this.$i18n.locale = 'ar'
        this.$vuetify.lang.current = 'ar'
        this.$validator.localize('ar', ar)
        this.user_name = store.state.token.name_ar
        this.company_name = store.state.token.company_name_ar
        store.dispatch('SetLanguage', 'ar')
      }

      this.fnGetMenu()
    },

    fnGetMenu() {
      this.items = [
        {
          pricon : 'lnb_01',
          icon: 'mdi-chevron-down',
          text: this.$t('common.menu.my_application'),
          model: false,
          childModel: false,
          login: false,
          path: '/myapplication/list',
          required_login : true, // 로그인이 필요한 페이지
          return_page_yn : true  // 리턴 할 페이지가 존재
        },
        {
          pricon : 'lnb_02',
          icon: 'mdi-chevron-down',
          text: this.$t('common.menu.my_request'),
          model: false,
          childModel: false,
          login: false,
          path: '/myrequest/list',
          required_login : true,
          return_page_yn : true
        },
        {
          pricon : 'lnb_03',
          icon: 'mdi-chevron-down',
          text: this.$t('common.menu.new_application'),
          model: false,
          childModel: false,
          login: true,
          children: [
            {
              text: this.$t('common.menu.temporary_protection'),
              path: '/application/temporaryprotection/step1',
              model: false,
              required_login : true,
              return_page_yn : false
            },
            {
              text: this.$t('common.menu.patent'),
              path: '/application/patent/step1',
              model: false,
              required_login : true,
              return_page_yn : false
            },
            {
              text: this.$t('common.menu.utility_model'),
              path: '/application/utilitymodel/step1',
              model: false,
              required_login : true,
              return_page_yn : false
            },
            {
              text: this.$t('common.menu.ic_topography'),
              path: '/application/ictopography/step1',
              model: false,
              required_login : true,
              return_page_yn : false
            },
          ]
        },
        {
          pricon : 'lnb_04',
          icon: 'mdi-chevron-down',
          text: this.$t('common.menu.modification'),
          model: false,
          childModel: false,
          login: true,
          children: [
            {
              text: this.$t('common.menu.voluntary_amendment'),
              path: '/modification/voluntaryamendment',
              model: false,
              required_login : true,
              return_page_yn : true
            },
            {
              text: this.$t('common.menu.change_name_address'),
              path: '/modification/changenameaddress',
              model: false,
              required_login : true,
              return_page_yn : true
            },
            {
              text: this.$t('common.menu.change_ownership'),
              path: '/modification/changeownership',
              model: false,
              required_login : true,
              return_page_yn : true
            },
            {
              text: this.$t('common.menu.assign_change_agent'),
              path: '/modification/assignchangeagent',
              model: false,
              required_login : true,
              return_page_yn : true
            },
            {
              text: this.$t('common.menu.withdrawal'),
              path: '/modification/withdrawal',
              model: false,
              required_login : true
            },
            {
              text: this.$t('common.menu.abandonment'),
              path: '/modification/abandonment',
              model: false,
              required_login : true,
              return_page_yn : true
            },
            {
              text: this.$t('common.menu.register_license'),
              path: '/modification/registerlicense',
              model: false,
              required_login : true,
              return_page_yn : true
            },
            {
              text: this.$t('common.menu.modify_license'),
              path: '/modification/modifylicense',
              model: false,
              required_login : true,
              return_page_yn : true
            }
          ]
        },
        {
          pricon : 'lnb_05',
          icon: 'mdi-chevron-down',
          text: this.$t('common.menu.maintenance'),
          model: false,
          childModel: false,
          login: true,
          children: [
            {
              text: this.$t('common.menu.pay_annual_fee'),
              path: '/maintenance/payannualfee',
              model: false,
              required_login : true,
              return_page_yn : true
            },
            {
              text: this.$t('common.menu.restoration'),
              path: '/maintenance/restoration',
              model: false,
              required_login : true,
              return_page_yn : true
            },
          ]
        },
        {
          pricon : 'lnb_06',
          icon: 'mdi-chevron-down',
          text: this.$t('common.menu.appeal_opposition'),
          model: false,
          childModel: false,
          login: true,
          children: [
            {
              text: this.$t('common.menu.appeal'),
              path: '/appeal',
              model: false,
              required_login : true,
              return_page_yn : true
            },
            {
              text: this.$t('common.menu.opposition'),
              path: '/opposition',
              model: false,
              required_login : true,
              return_page_yn : true
            },
          ]
        },
        {
          pricon : 'lnb_07',
          icon: 'mdi-chevron-down',
          text: this.$t('common.menu.public_service'),
          model: false,
          childModel: false,
          login: true,
          children: [
            {
              text: this.$t('common.menu.research_service'),
              path: '/public/research/step1',
              model: false,
              required_login : true,
              return_page_yn : false
            },
            {
              text: this.$t('common.menu.translation_and_audit'),
              path: '/public/translationandaudit',
              model: false,
              required_login : true,
              return_page_yn : true
            },
            {
              text: this.$t('common.menu.certified_copy_service'),
              path: '/public/certifiedcopyservice',
              model: false,
              required_login : true,
              return_page_yn : true
            },
            {
              text: this.$t('common.menu.writing_and_printing'),
              path: '/public/writingandprinting',
              model: false,
              required_login : true,
              return_page_yn : true
            },
            {
              text: this.$t('common.menu.in_person_meeting'),
              path: '/public/inpersonmeeting',
              model: false,
              required_login : true,
              return_page_yn : true
            },
          ]
        },
        {
          pricon : 'lnb_09',
          icon: 'mdi-chevron-down',
          text: this.$t('common.menu.e_service_conversion'),
          model: false,
          childModel: false,
          login: true,
          path: '/eserviceconversion/step1',
          required_login : true,
          return_page_yn : true
        },
        {
          pricon : 'lnb_10',
          icon: 'mdi-chevron-down',
          text: this.$t('common.menu.verify_certified_copy'),
          model: false,
          childModel: false,
          login: true,
          path: '/verifycertifiedcopy',
          required_login : false,
          return_page_yn : true
        },
        {
          pricon : 'lnb_08',
          icon: 'mdi-chevron-down',
          text: this.$t('common.menu.information'),
          model: false,
          childModel: false,
          login: true,
          children: [
            {
              text: this.$t('common.menu.notice'),
              path: '/information/notice',
              model: false,
            },
            {
              text: this.$t('common.menu.faqs'),
              path: '/information/faqs',
              model: false,
            },
            {
              text: this.$t('common.menu.fee'),
              path: '/information/fee',
              model: false,
            },
            {
              text: this.$t('common.menu.forms'),
              path: '/information/forms',
              model: false,
            }
          ]
        },
        {
          pricon: 'lnb_11',
          icon: 'mdi-chevron-down',
          text: this.$t('common.menu.help'),
          model: false,
          childModel: false,
          login: true,
          children: [
            {
              text: this.$t('common.menu.1_1_Q_A'),
              path: '/information/qna',
              model: false,
              required_login : true,
              return_page_yn : true
            },
            {
              text: this.$t('common.menu.user_guide'),
              path: '/information/userguide',
              model: false,
            }
          ]
        }
      ]
    },

    onResize () {
      this.windowSize = { x: window.innerWidth }
      this.windowSize.x < 1199 ? this.asidebool = false : this.asidebool = true;
      this.windowSize.x > 1199 ? this.slideactive = false : '';

      this.btneventwrapheight = this.windowSize.x / 5;
    },
    fnGoCheck2(item) {
      let items = this.items
      let _this = this

      items.forEach((item, index) => {
        _this.items[index].model = false
        if (_this.items[index].children) {
          let subItems = _this.items[index].children
          subItems.forEach((subItem, subIndex) => {
            _this.items[index].children[subIndex].model = false
          })
        }
      })

      this.fnGoCheck(item)
    },
    fnGoCheck(item){
      if(utils.isNull(store.state.token.access_token)){
        if(item.required_login){
          let path = '/signin'
          if(item.return_page_yn){
            path += '?return_url=' + item.path
          }
          this.fnCheckIpAddress(path)
        }else{
          this.fnGoPath(item.path)
        }
      }else{
        this.fnGoPath(item.path)
      }
    },
    fnGoPath (path) {
      if (path.indexOf('/signin') > -1 || path.indexOf('/signup') > -1) {
        this.fnCheckIpAddress(path)
        return
      }

      let blnConfirm = false
      let tit = this.$t('common.common.confirm')
      let txt = ''
      let url = '' // 신청 url

      if (path === '/application/temporaryprotection/step1') {
        blnConfirm = true
        txt = this.$t('menu.new_application.confirm.temporary_protection')
        url = '/receivings/temporary'
      } else if (path === '/application/patent/step1') {
        blnConfirm = true
        txt = this.$t('menu.new_application.confirm.patent')
        url = '/receivings/patent'
      } else if (path === '/application/utilitymodel/step1') {
        blnConfirm = true
        txt = this.$t('menu.new_application.confirm.utility_model')
        url = '/receivings/utility/model'
      } else if (path === '/application/ictopography/step1') {
        blnConfirm = true
        txt = this.$t('menu.new_application.confirm.ic_topography')
        url = '/receivings/ic'
      } else if (path === '/public/research/step1') {
        blnConfirm = true
        txt = this.$t('menu.public_service.confirm.research_service')
        url = '/receivings/research'
      }

      if (blnConfirm) {
        let options = {
          title: tit,
          text: txt,
          yes: {
            text: this.$t('common.button.yes'),
            event: 'confirm',
            callback: {
              path: path,
              url : url
            }
          },
          no: {
            text: this.$t('common.button.no')
          }
        }
        eventBus.$emit('SHOW_CONFIRM_DIALOG'+ this.id, options)
      } else {
        // 라우터에 담긴 path와 요청 path가 같을 시 화면 새로고침
        if(this.$route.path == path){
          window.location.reload()
        }else{
          this.$router.push(path)
          this.slideactive = false
        }
      }
    },
    // 메뉴에서 컨펌에 동의 했을 시에 신청 후에 url에 receipt_no가 넘어가도록 변경
    fnGoPath2 (callback) {
      requestApi({
        url: callback.url,
        method: 'POST',
        callback: (res) => {
          if (res.res_code === '200') {
            this.$router.push(callback.path + '/' + res.data.receipt_no)
            eventBus.$emit('CLOSE_CONFIRM_DIALOG'+ this.id)
            this.slideactive = false
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGoPath2(callback)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnCheckIpAddress(path) {
      requestApi({
        url: '/config/codes/ipaddress',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.$router.push(path)
          } else {
            eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
          }
        }
      })
    },
    // Sign Out
    fnSignOut () {
      requestApi({
        url: '/autho/logout',
        method: 'GET',
        callback: (res) => {
          // logout 에서는 token 관련 오류도 logout 과 동일하게 처리
          if (res.res_code === '200' || res.res_code === '401011' || res.res_code === '401013' || res.res_code === '401014') {
            // store 정보 초기화
            store.dispatch('SetInitToken')
            store.dispatch('SetInitAuthHeader')

            // 읽지 않은 통지서 개수 초기화
            eventBus.$emit('NOTIFICATION_INIT')
            // unpaymnet 개수 초기화
            eventBus.$emit('PAYMENT_INIT')

            // 메인 페이지로 이동
            this.$router.push('/main')
          } else {
            eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
          }
        }
      })
    }
  },

}
</script>
